import { Stack } from "@mui/material";
import React from "react";
import { parse, isValid } from 'date-fns';
import TextBox from "../Textbox";
import styled from "@emotion/styled";
import { COLOR_MAP } from "../../../constants/ColorNames";
import { DateRange } from "react-day-picker";

type CustomHeaderProps = {
  range: DateRange | undefined;
  handleRangeChange: (newRange: any) => void;
};

const InputWrapper = styled.div`
  position: absolute;
  top: 8px;
  left: 0;
`

const DateLabelText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  padding : 12px 0 0 10px;
  color: ${COLOR_MAP.GREY_1}
`;

// helpers

const parseDateFromDDMMYYYY = (dateString: string) => {
  const [day, month, year] = dateString.split('/').map(Number);

  if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
    return parse(`${year}-${month}-${day}`, 'yyyy-MM-dd', new Date());
  }
  return; // Invalid date format
}

const dateRangeFormatter = (date: Date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

const parseDate = (str: string) => {
  const [day, month, year] = str.split('/');
  if ((day && day.length !== 2) || (month && month.length !== 2) || (year &&year.length !== 4)) return null;
  const parsed = parse(str, 'dd/MM/yyyy', new Date());
  if (isValid(parsed)) {
    return parsed;
  }
  return null;
};

const isDateValid = (str: string) => {
  return isValid(parseDate(str));
};

const getDefaultInputRange = (range: any) => {
  return {
    to : range && range.to ? dateRangeFormatter(range.to) : '',
    from : range && range.from ? dateRangeFormatter(range.from) : '',
  }

}

const CustomHeader = (props: CustomHeaderProps) => {
  const { range, handleRangeChange } = props;
  const [inputRange, setInputRange] = React.useState<{ to: string, from: string }>(getDefaultInputRange(range))


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, type: 'from' | 'to') => {
    let newValue = e.target.value;
    let inputValue = inputRange[type];
    const lastCharOfInputValue = inputValue.length ? inputValue[inputValue.length -1] : '';

    if(newValue.length >=11){
      return
    }

    if (newValue.length === 2 && lastCharOfInputValue !== '/') {
      newValue = newValue + '/';
    } else if (newValue.length === 5 && lastCharOfInputValue !== '/') {
      newValue = newValue + '/';
    }

    const newInputRange = { ...inputRange };
    newInputRange[type] = newValue;
    setInputRange(newInputRange);

    const isValidDate = isDateValid(newInputRange[type]);

    if(isValidDate){
      const date = parseDateFromDDMMYYYY(newInputRange[type]);
      const newRange = { ...range };
      newRange[type] = date;
      handleRangeChange(newRange);
    }

  };


  return (
    <InputWrapper>
      <DateLabelText>Custom date</DateLabelText>
      <Stack
        direction="row"
        sx={{
          padding: '0.8rem',
          paddingTop: '0.4rem'
        }}
        spacing={1}
        width="95%"
      >
        <TextBox
          id='start-date'
          placeholder="dd/mm/yyyy"
          textValue={inputRange.from}
          handleChange={(e) => handleInputChange(e, 'from')}
        />
        <TextBox
          id='end-date'
          placeholder="dd/mm/yyyy"
          textValue={inputRange.to}
          handleChange={(e) => handleInputChange(e, 'to')}
        />
      </Stack>
    </InputWrapper>
  )
};

export default CustomHeader;